import { NgModule } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import {
  BaseService,
  ConfigService,
  DocumentService,
  ICompany,
  ICompanyConfig,
  MainModule,
} from "src/app/main";
import { RealRapidoIndexComponent } from "../../real-rapido/main/components/index/real-rapido-index.component";
import { SampaioIndexComponent } from "../../sampaio/main/components/index/sampaio-index.component";
import { UtilIndexComponent } from "../../util/main/components/index/util-index.component";
import {
  ALL_GUANABARA_MAIN_COMPONENTS,
  GuanabaraIndexComponent,
} from "./components";
import { MAZE_SCRIPT, SALESFORCE_COLLECT_TRACK_CODE } from "./constants";
import { GUANABARA_MAIN_ROUTES } from "./guanabra-main-routing.module";
import { ALL_COOKIE_CONSENT_MODAL_COMPONENT } from "src/app/cookie-consent/components/index";
// import { CookieSettingsModalComponent } from "src/app/cookie-consent/components/cookie-settings/cookie-settings.component";

const GOOGLE_TAG_MANAGER = `(function(w, d, s, l, i) {
  w[l] = w[l] || []; w[l].push({
    'gtm.start':
      new Date().getTime(), event: 'gtm.js'
  }); var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
}) (window, document, 'script', 'dataLayer', 'GTM-PMCP85K');`;



@NgModule({
  declarations: [ALL_GUANABARA_MAIN_COMPONENTS, ALL_COOKIE_CONSENT_MODAL_COMPONENT],
  imports: [RouterModule, MainModule],
  providers: [],
})
export class GuanabaraMainModule implements ICompany {
  private config: ICompanyConfig;
  private company: string = (() => {
    if (window.location.pathname.includes("/sampaio")) {
      return "/sampaio";
    } else if (window.location.pathname.includes("/realexpresso")) {
      return "/real-rapido";
    } else if (window.location.pathname.includes("/util")) {
      return "/util";
    }
    return "/guanabara";
  })();

  public constructor(
    private router: Router,
    private docHelperService: DocumentService,
    private configService: ConfigService,
    private base: BaseService
  ) {
    this.router.resetConfig([...GUANABARA_MAIN_ROUTES, ...this.router.config]);
    this.config = this.base.configService.company;
  }
  public async configure(): Promise<void> {
    this.docHelperService.setHtmlLang("pt-br");
    this.docHelperService.title.setTitle(
      "Viaje Guanabara: Compre sua passagem de ônibus"
    );
    this.docHelperService.meta.addTag({
      name: "description",
      content:
        "O melhor preço para Fortaleza, Sobral, São Paulo, Recife, Natal, Rio de Janeiro, Belo Horizonte e muito mais. Reserve já!",
    });
    this.docHelperService.meta.addTag({
      name: "theme-color",
      content: "#942331",
    });
    this.docHelperService.addLink(
      "image/x-icon",
      "shortcut icon",
      `${this.configService.config.cdnUrl}_common/img/favicons${this.company}.ico`
    );
    this.docHelperService.addLink(
      "image/x-icon",
      "icon",
      `${this.configService.config.cdnUrl}_common/img/favicons${this.company}.ico`
    );
    await this.docHelperService.addLink(
      "text/css",
      "stylesheet",
      `${this.configService.config.cdnUrl}ecommerce/styles/companies${this.company}${this.company}.min.css`
    );
    this.docHelperService.addScript(
      "//script.crazyegg.com/pages/scripts/0118/8061.js",
      false,
      true
    );

    if (this.configService.config.googleTagManagerActive) {
      this.docHelperService.addContentScript(GOOGLE_TAG_MANAGER);
    }
    if (this.configService.config.mazeActive) {
      this.docHelperService.addContentScript(MAZE_SCRIPT);
    }
  }

  public getIndex(): any {
    switch (this.company) {
      case "/sampaio":
        return SampaioIndexComponent;
      case "/real-rapido":
        return RealRapidoIndexComponent;
      case "/util":
        return UtilIndexComponent;
      default:
        return GuanabaraIndexComponent;
    }
  }
}
